import { createFileRoute } from "@tanstack/react-router";
import ProjectDetail from "@/pages/ProjectDetail";
import { supabase } from "@/integrations/supabase/client";
import { seo, breadcrumbSchema } from "@/lib/seo";

export const Route = createFileRoute("/_site/projects/$slug")({
  // Server-side so each project's own title/description reach crawlers.
  loader: async ({ params }) => {
    const { data } = await supabase
      .from("projects")
      .select("title, description, image_url, location")
      .eq("slug", params.slug)
      .eq("published", true)
      .or("scheduled_at.is.null,scheduled_at.lte.now()")
      .maybeSingle();

    return data ?? null;
  },
  head: ({ params, loaderData }) => {
    if (!loaderData) {
      return seo({
        title: "Project Not Found",
        description: "This project could not be found.",
        path: `/projects/${params.slug}`,
        noindex: true,
      });
    }

    const desc = loaderData.description ?? "";
    const description = desc.length > 155 ? `${desc.slice(0, 152)}...` : desc;

    return seo({
      title: loaderData.title,
      description,
      path: `/projects/${params.slug}`,
      image: loaderData.image_url ?? undefined,
      jsonLd: breadcrumbSchema([
        { name: "Home", path: "/" },
        { name: "Projects", path: "/projects" },
        { name: loaderData.title, path: `/projects/${params.slug}` },
      ]),
    });
  },
  component: ProjectDetail,
});
